import React from 'react';

import moment from 'moment';

import {ErrorMessage} from 'shells/form/error-message';
import {FormField} from 'shells/form/form-field';
import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

type Props = {
    anchor: any;
    onCancel: () => void;
    selectedCount: number;
    onSubmit: (arg1: string) => Promise<any>;
    entityType: 'leads' | 'contacts';
};

export function BulkSyncPopover(props: Props) {
    const [isSubmitComplete, setIsSubmitComplete] = React.useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const entityName = props.entityType === 'leads' ? 'Lead' : 'Contact';
    const defaultNamedExport = React.useMemo(
        () => `${entityName} Sync: ${moment().format('MMM D, H:mm A')}`,
        [entityName]
    );
    const [namedExport, setNamedExport] = React.useState<string>(defaultNamedExport);
    const [errorMessage, setErrorMessage] = React.useState<string | null | undefined>(null);

    return (
        <Popover anchor={props.anchor} onBlur={props.onCancel}>
            <PopoverForm
                errorSaving={Boolean(errorMessage)}
                allowTitleWrapping={true}
                onClose={props.onCancel}
                saveButtonText='Sync'
                title={getTitleText(props.selectedCount, entityName)}
                saveButtonDisabled={namedExport.trim().length === 0}
                onSubmit={() => {
                    setIsSubmitting(true);
                    props
                        .onSubmit(namedExport)
                        .then(() => {
                            setIsSubmitting(false);
                            setIsSubmitComplete(true);
                        })
                        .catch((err) => {
                            setIsSubmitting(false);
                            if (err && err.message) {
                                setErrorMessage(err.message);
                            } else {
                                setErrorMessage(
                                    'Sorry, something went wrong. Please try again later.'
                                );
                            }
                        });
                }}
                isSaving={isSubmitting}
            >
                {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : undefined}
                {isSubmitComplete && !errorMessage ? (
                    <Body>Sync started! Your changes should appear in a few minutes.</Body>
                ) : (
                    <FormField innerId='namedExport' label='Name this sync' noMargin={true}>
                        <TextField
                            focusOnMount={true}
                            // @ts-expect-error
                            name='namedExport'
                            onChange={(newValue) => {
                                setNamedExport(newValue);
                            }}
                            placeholder='Choose a descriptive sync name'
                            value={namedExport}
                        />
                    </FormField>
                )}
                <div style={{height: '16px'}} />
            </PopoverForm>
        </Popover>
    );
}

function getTitleText(selectedCount: number, entityName: string) {
    return selectedCount === 1
        ? `Sync 1 ${entityName} to WebFX`
        : `Sync ${selectedCount} ${entityName}s to WebFX`;
}
